import { render } from "./BaitShop.vue?vue&type=template&id=ef9f56dc"
import script from "./BaitShop.vue?vue&type=script&lang=js"
export * from "./BaitShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__